import { LandingSiteRouteNames } from './route-names.enum';
import { formatPath } from './utils';

const HomePage = () => import('../views/landing-site/Home.vue');
const PrivacyPolicy = () => import('../views/landing-site/PrivacyPolicy.vue');
const AppPrivacyPolicy = () => import('../views/landing-site/AppPrivacyPolicy.vue');
const TermsOfUse = () => import('../views/landing-site/TermsOfUse.vue');
const RemoveDataPage = () => import('../views/landing-site/RemoveData.vue');
const ReferralLanding = () => import('../views/landing-site/ReferralLanding.vue');
const OptOutPage = () => import('../views/landing-site/OptOutPage.vue');

export const landingSiteRouter = [
  {
    path: formatPath(LandingSiteRouteNames.Beauty),
    name: LandingSiteRouteNames.Beauty,
    component: () => import('../views/landing-site/Beauty.vue')
  },
  {
    path: '',
    name: LandingSiteRouteNames.Home,
    component: HomePage
  },
  {
    path: formatPath(LandingSiteRouteNames.PrivacyPolicy),
    name: LandingSiteRouteNames.PrivacyPolicy,
    component: PrivacyPolicy
  },
  {
    path: formatPath(LandingSiteRouteNames.AppPrivacyPolicy),
    name: LandingSiteRouteNames.AppPrivacyPolicy,
    component: AppPrivacyPolicy
  },
  {
    path: formatPath(LandingSiteRouteNames.TermsOfUse),
    name: LandingSiteRouteNames.TermsOfUse,
    component: TermsOfUse
  },
  {
    path: formatPath(LandingSiteRouteNames.RemoveData),
    name: LandingSiteRouteNames.RemoveData,
    component: RemoveDataPage
  },
  {
    path: formatPath(LandingSiteRouteNames.Referral),
    name: LandingSiteRouteNames.Referral,
    component: ReferralLanding
  },
  {
    path: '/opt-out',
    name: 'OptOut',
    component: OptOutPage
  }

];

